import React from 'react'
import { TableRow, TableCell, Skeleton, Box } from '@mui/material'

const TableSkeleton = ({ columns, rows = 5, avatar = false }) => {
    return (
        <>
            {[...Array(rows)].map((_, index) => (
                <TableRow key={`skeleton-${index}`}>
                    {/* Avatar Column (Optional) */}
                    {avatar && (
                        <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box>
                                    <Skeleton variant="text" width={120} />
                                    <Skeleton variant="text" width={80} />
                                </Box>
                            </Box>
                        </TableCell>
                    )}

                    {/* Standard Columns */}
                    {[...Array(avatar ? columns - 2 : columns - 1)].map((_, colIndex) => (
                        <TableCell key={`col-${colIndex}`}>
                            <Skeleton variant="text" width="80%" />
                        </TableCell>
                    ))}

                    {/* Actions Column (Always last) */}
                    <TableCell align="right">
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Skeleton variant="circular" width={32} height={32} />
                            <Skeleton variant="circular" width={32} height={32} />
                        </Box>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}

export default TableSkeleton
